import { Drawer } from '@mui/material';
import React from 'react';
import BackdropCenteredProgress from '../../progress/backdrop-centered-progress/backdrop-centered-progress.component';
import UtilityDrawerTitle from './utility-drawer-title/utility-drawer-title.component';

export type UtilityDrawerProps = {
  anchor?: 'right' | 'top' | 'bottom' | 'left';
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  open: boolean;
  onClose?: ((e: any) => void) | undefined;
  disableBackdropClose?: boolean;
  isLoading?: boolean;
  hideBackdrop?: boolean;
  children: React.ReactNode;
  width?: any;
  'data-testid'?: string;
  sx?: object;
};

const UtilityDrawer = ({
  anchor = 'right',
  title,
  subtitle,
  open,
  onClose,
  disableBackdropClose = false,
  isLoading = false,
  children,
  width,
  'data-testid': dataTestId,
  ...rest
}: UtilityDrawerProps) => {
  const handleClose = (e, reason) => {
    if (reason === 'backdropClick' && disableBackdropClose && !isLoading)
      return;
    onClose(e);
  };

  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={handleClose}
      // @ts-ignore
      PaperProps={{ 'data-testid': dataTestId }}
      sx={{
        '& .MuiDrawer-paper': {
          width: width ?? ['100%', 450],
          overflowX: 'hidden',
        },
      }}
      {...rest}
    >
      <BackdropCenteredProgress isLoading={isLoading} />
      <UtilityDrawerTitle title={title} subtitle={subtitle} onClose={onClose} />
      {children}
    </Drawer>
  );
};

export default UtilityDrawer;
